import { datadogRum } from '@datadog/browser-rum';
import { beforeSend } from './utils';
import type { DatadogRumConfig } from './types';

let initialized = false;

export default function initRum(config: DatadogRumConfig): void {
  if (initialized) {
    return;
  }

  if (config.env === 'local') {
    return;
  }

  if (config.shouldInit && !config.shouldInit()) {
    return;
  }

  datadogRum.init({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    site: config.site ?? 'datadoghq.com',
    service: config.service,
    env: config.env,
    sessionSampleRate: config.sessionSampleRate ?? 100,
    sessionReplaySampleRate: config.sessionReplaySampleRate ?? 5,
    traceSampleRate: config.traceSampleRate ?? 100,
    silentMultipleInit: true,
    version: config.applicationVersion,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: config.defaultPrivacyLevel ?? 'allow',
    allowedTracingUrls: config.allowedTracingUrls,
    plugins: config.plugins,
    beforeSend,
  });

  initialized = true;
}
